export const isLogin = function () {
    const token = localStorage.getItem('fmEE');
    return !!token;
};
